module.exports = __webpack_public_path__ + "img/pickaxe-gold.5401ba1c.svg";